var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowCarbonDiet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C3E5C6",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9366 7.4602C21.9643 7.39437 21.9274 7.33419 21.8556 7.32799C20.9766 7.25504 15.9391 6.99061 16.5666 10.5859C19.5678 12.6807 21.6018 8.25567 21.9366 7.4602Z",
    fill: "#C3E5C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.222 10.7188C14.9654 11.2336 15.3573 11.9148 15.574 12.6207C15.8607 12.6971 16.1873 12.679 16.4544 12.5667C16.3081 11.5675 15.9333 10.7825 15.0816 10.0535C14.94 9.93264 14.8158 9.93246 14.6583 10.0324L14.2141 10.3145C13.9962 10.4529 14.0098 10.572 14.222 10.7188Z",
    fill: "#C3E5C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5385 13.0533C16.2305 13.2377 15.7694 13.2377 15.4614 13.0533C11.8239 10.8743 7.92004 13.8432 9.53367 18.3831C10.4204 20.8764 12.3863 24.9703 15.7691 23.3286C15.8983 23.2661 16.1013 23.2661 16.2305 23.3286C19.6138 24.9703 21.5795 20.8764 22.4661 18.3831C24.0797 13.8432 20.1759 10.8743 16.5385 13.0533Z",
    fill: "#C3E5C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowCarbonDiet);
export default __webpack_public_path__ + "static/media/Low-carbon-diet.e306ab45.svg";
export { ForwardRef as ReactComponent };